import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import {
  getLogger,
  inIframe,
  initializeAnalytics,
  initializeLogger,
  observerResizeIframe,
  ThemeProvider
} from '@chilecompra/react-kit'
import Package from '../package.json'
import {
  REACT_APP_ENVIRONMENT,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION,
  REACT_APP_MERCADO_PUBLICO_BASE_URL
} from './config/settings/environment'
import storeSingleton from './config/store/store'
import Routing from './Routing'

initializeAnalytics({
  gaKey: REACT_APP_GOOGLE_ANALYTICS_KEY,
  gaKeySV: REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  gtmId: REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  hotjarId: REACT_APP_HOTJAR_ID,
  hotjarSV: REACT_APP_HOTJAR_SNIPPET_VERSION
})
initializeLogger({ env: REACT_APP_ENVIRONMENT === 'prod' ? 'prod' : 'dev' })

const store = storeSingleton()
const logger = getLogger('App')
const container = document.getElementById('__root')
const root = createRoot(container)

logger.info(`React v${React.version}`)
logger.info(`Búsqueda de Compradores v${Package.version}`)

// This enables communication between react and MP applications to resize the fraDetalle iframe.
if (inIframe()) {
  observerResizeIframe(REACT_APP_MERCADO_PUBLICO_BASE_URL)
}

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <ThemeProvider>
        <Routing />
      </ThemeProvider>
    </ReduxProvider>
  </StrictMode>
)
